import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { Observable } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class MediaService {
  entity: string = "/upload/files";
  constructor(private http: HttpClient, private authService: AuthService) {}

  delete(id: string) : Observable<any>{
    return this.http.delete(environment.api + this.entity + "/" + id, {
      headers: {
        Authorization: "Bearer " + this.authService.currentUserValue.token,
      },
    });
  }

}
